/**
 * Integrytas Group - User-Defined Column Engine (UDC)
 * UdcFacets — one-line filter-bar drop-in for user-defined fields.
 *
 * Renders a <FacetFilter> for each custom field an admin placed on this page's
 * filter bar (from useUdcGrid). Drop it into a list page's toolbar:
 *
 *   const udc = useUdcGrid(entity, PAGE_CODE, { pkColumn, rows });
 *   ...<UdcFacets grid={udc} />
 *
 * and combine udc.matchRow(row) into the page's `filtered` memo. Renders nothing
 * until custom filter fields exist, so it is safe to add unconditionally.
 */

import { FacetFilter } from './FacetFilter';
import type { UseUdcGrid } from '../../hooks/use_udc_grid';

export function UdcFacets({ grid }: { grid: UseUdcGrid }) {
  if (grid.facets.length === 0) return null;
  return (
    <>
      {grid.facets.map(f => (
        <FacetFilter
          key={f.key}
          label={f.label}
          options={f.options}
          selected={grid.filterValues[f.key] ?? []}
          onChange={v => grid.setFilter(f.key, v)}
        />
      ))}
    </>
  );
}
